@import "src/style/lib";

.products-page-aside {
  background-color: $bjelin-smoke;
  min-height: 44rem;
  padding: 1rem;

  h3 {
    font-size: 18px;
    font-weight: 600;
  }
}
